// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-md>
    <v-card>
      <v-toolbar flat>
        <v-btn icon @click="exit"><v-icon>clear</v-icon></v-btn>
        <!-- <v-toolbar-title v-if="newItem">Add {{ name }}</v-toolbar-title> -->
        <v-toolbar-title>Edit {{ name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn v-if="canModify" light color="success" @click="saveItem">Save</v-btn>
        <!-- <v-btn v-if="canDelete" light color="error" @click.stop="showDeleteDialog = true">Delete</v-btn> -->
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
            v-model="item.description"
            label="Description"
            :disabled="!canModify"
            required
            hide-details
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
            v-model="item.subject"
            label="Subject"
            :disabled="!canModify"
            required
            hide-details
            >
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12>
            <span v-html="item.value"></span>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs12>
            <v-textarea
            v-model="item.value"
            auto-grow
            label="Template"
            outline
             ></v-textarea>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <!-- <v-dialog v-model="showDeleteDialog" max-width="300px">
      <v-card>
        <v-card-title>
          <div class="headline">Delete?</div>
        </v-card-title>
        <v-card-text>Are you sure you want to delete this {{ name }}?  This action cannot be undone.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="showDeleteDialog = false">Cancel</v-btn>
          <v-btn flat color="red" @click.native="deleteItem">I'm Sure</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->

    <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import {ENDPOINT} from '@/shared/constants'
  import {checkPermission} from 'vue-common/components/user'
  import {AXIOSAPI} from 'vue-common/components/requests-common'
  import ErrorSnackbar from 'vue-common/components/ErrorSnackbar'
  import {PERMISSIONS} from 'vue-common/components/constants'

  export default {
    components: {
      ErrorSnackbar
    },

    data () {
      return {
        endpoint: 'emailtemplates',
        name: 'Template',
        id: 'NewLicenseTemplate',
        errorText: '',
        item: {},
        newItem: false,
        showDeleteDialog: false
      }
    },

    created () {
      // if (this.$route.params.id === 'new') {
      //   this.newItem = true
      // }
      // this.id = this.$route.params.id

      this.getItem()
    },

    computed: {
      ...mapGetters([
        'accessRules'
      ]),

      canModify: function () {
        return checkPermission(this.accessRules, this.endpoint, PERMISSIONS.MODIFY)
      },

      canDelete: function () {
        return checkPermission(this.accessRules, this.endpoint, PERMISSIONS.DELETE)
      }
    },

    methods: {
      // deleteItem: function () {
      //   AXIOSAPI.delete(ENDPOINT + this.endpoint + '/' + this.id).then((response) => {
      //     this.exit()
      //   }).catch(e => {
      //     console.log(e)
      //     this.errorText = e.response.statusText + ': ' + e.response.data
      //   })
      // },

      getItem: function () {
        if (this.newItem) {
        } else {
          AXIOSAPI.get(ENDPOINT + this.endpoint + '/' + this.id).then(response => {
            this.item = response.data
          })
        }
      },

      saveItem: function () {
        if (this.newItem) {
          AXIOSAPI.post(ENDPOINT + this.endpoint, this.item).then(response => {
            // this.exit()
          }).catch(e => {
            console.log(e)
            this.errorText = e.response.statusText + ': ' + e.response.data
          })
        } else {
          AXIOSAPI.put(ENDPOINT + this.endpoint + '/' + this.item._id, this.item).then(response => {
            // this.exit()
            this.errorText = 'Template saved'
          }).catch(e => {
            console.log(e)
            this.errorText = e.response.statusText + ': ' + e.response.data
          })
        }
      },

      exit: function () {
        this.$router.go(-1)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/EmailTemplateEdit.vue